// @ts-nocheck


import { EllipsisOutlined } from '@ant-design/icons';
import React, { Component } from 'react';
import moment from 'moment';
import Button from 'antd/lib/button';
import qs from 'query-string';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import Menu from 'antd/lib/menu';
import { notificationLoading } from './../../../components/Notifications';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';







import {
  washingTypes,
  washingStatusTypes,
  washingStatusEnum } from
'./../../../lib/enum';
import {
  getListInitialState,
  setQueryParams,
  convertVehicleToString,
  formatDateTimeToString } from
'./../../../lib/helpers';

import { Section } from './../../../components/layout';
import { Popconfirm, Table, Dropdown } from './../../../components/ui';
import Header from './../../../components/layout/Header';
import { washingApi } from './../../../lib/api';
import { withUserAccess } from './../../withUserAccess';



import { setFilter } from '../../../ducks/persistFilters';

import { canHandleService, ACT_COLUMNS } from '../lib';

import WashingsFilter from './Filter';

import DriverFactPopover from './DriverFactPopover';











export const COLUMNS = [
{
  title: 'Номер',
  dataIndex: 'id'
},
{
  title: 'Планируемая дата',
  dataIndex: 'date',
  render: (date) => {
    const monthYear = moment.utc(date).format('MMMM YYYY года');
    return monthYear.charAt(0).toUpperCase() + monthYear.slice(1);
  }
},
{
  title: 'Дата выполнения',
  key: 'factDate',
  dataIndex: 'factDate',
  render: (value) =>
  value ? formatDateTimeToString(value, 'DD.MM.YYYY') : null
},
{
  title: 'Вид мойки',
  dataIndex: 'type',
  render: (type) => washingTypes[type]
},
{
  title: 'ТС',
  dataIndex: 'vehicle',
  render: (vehicle) => convertVehicleToString(vehicle)
},
{
  title: 'Статус',
  dataIndex: 'state',
  render: (state) => washingStatusTypes[state]
},
{
  title: 'Стоимость',
  dataIndex: 'paymentAmount'
}];


export class List extends Component {
  static defaultProps = {
    location: {}
  };
  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };
  columns = [...COLUMNS, ...ACT_COLUMNS];

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  applyFilter = async (filter) => {
    await this.setPersistFilter(filter);
    await this.fetchWashingList();
  };

  cleanFilter = async () => {
    await this.setPersistFilter({});
    await this.fetchWashingList();
  };

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    if (this.canAdd()) {
      this.columns.push({
        title: '',
        width: '30px',
        onCell: () => ({ onClick: (e) => e.stopPropagation() }),
        render: (record) => {
          return (
            <Dropdown
              overlay={
              <Menu>
                  {record.state === washingStatusEnum.scheduled &&
                <Menu.Item>
                      <DriverFactPopover
                    washing={record}
                    defaultDriverId={
                    record.driverId ||
                    record.vehicle && record.vehicle.driverId
                    }
                    onServerUpdate={(washing) => {
                      const records = [...this.state.data];
                      const index = records.findIndex(
                        (w) => w.id === washing.id
                      );
                      records[index] = washing;
                      this.setState({ data: records });
                    }} />

                    </Menu.Item>
                }
                  <Menu.Item>
                    <Popconfirm
                    title="Вы действительно хотите удалить талон?"
                    okText="Да"
                    cancelText="Нет"
                    placement="bottomRight"
                    onConfirm={() => {
                      if (record && record.id) {
                        this.deleteWashing(record.id);
                      }
                    }}>

                      Удалить
                    </Popconfirm>
                  </Menu.Item>
                </Menu>
              }>

              <EllipsisOutlined style={{ fontSize: 16, color: '#2770FF' }} />
            </Dropdown>);

        }
      });
    }
    await this.fetchWashingList(page);
  }

  fetchWashingList = async (
  page = 1,
  params = {}) =>
  {
    const { filterPath } = this.state;
    const filter = this.props.persistFilters[filterPath] || {};
    this.setState({ loading: true });
    const { data, totalCount } = await washingApi.fetchAllWashings({
      ...filter,
      page,
      ...params
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  deleteWashing = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await washingApi.deleteWashing(id);
      const records = [...this.state.data.filter((r) => r.id !== id)];
      this.setState({ data: records });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  handleRowClick = (id) => navigate(`/services/washings/${id}`);

  canAdd = () => canHandleService(this.props.userAccess);

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filterPath } =
    this.state;
    const filter = this.props.persistFilters[filterPath];
    return (
      <>
        <Header
          left={<h1>Мойки</h1>}
          right={
          this.canAdd() &&
          <Link to="/services/washings/new">
                <Button type="primary" data-cy="add">
                  Создать
                </Button>
              </Link>

          } />

        <Section>
          <WashingsFilter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            fetch={this.fetchWashingList}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            loading={loading}
            columns={this.columns}
            data={data.map((item) => ({
              ...item,
              key: item.id
            }))} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters
  }),
  {
    setFilter
  }
)(withUserAccess(List));
